<div formGroupName="receiptSearchConditionForm">
  <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
    <mat-form-field appearance="outline" class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>契約番号</mat-label>
        <input matInput formControlName="keiyakuNo" autocomplete="off" maxlength="15" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>お客さま番号</mat-label>
        <input matInput formControlName="okyakusamaNo" autocomplete="off" maxlength="10" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
      <mat-label>供給地点特定番号</mat-label>
        <input matInput formControlName="kyoukyuchitenTokuteiNo" autocomplete="off" maxlength="22" />
    </mat-form-field>
  </div>

<div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
  <mat-card-actions class="btn_area_right">
    <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickClear()">
        クリア
    </button>
  </mat-card-actions>

  <mat-card-actions class="btn_area_right">
    <button type="submit" mat-raised-button color="primary"
        [disabled]="parentForm.invalid || receiptSearchConditionForm.invalid || (!keiyakuNo.value && !kyoukyuchitenTokuteiNo.value && !okyakusamaNo.value)"
        class="btn" (click)="onClickSearch()">
        検索
    </button>
  </mat-card-actions>

  <mat-card-actions class="btn_area_right">
    <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickClose()">
        閉じる
    </button>
  </mat-card-actions>
</div>
